import classNames from "classnames";
import { motion } from "framer-motion";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";

import { useAuthContext } from "~/contexts/auth";
import { useConfiguration } from "~/contexts/configuration";
import useSubscriptions from "~/hooks/use-subscriptions";
import appRoutes from "~/utils/app-routes";
import crossCountryUtils from "~/utils/cross-country-utils";
import loyaltyUtils from "~/utils/loyalty-utils";

import Button from "../common/button";
import buttonStyles from "../common/button.module.scss";
import Icon from "../common/icon";
import styles from "./navigation.module.scss";

// TODO need to understand if that's correct
export const myAccountRoutes = [
  "",
  "purchases",
  "preferred-store",
  "loyalty",
  "wishlist",
  "settings",
  "addresses",
  // "payments",
  "returns",
  //"customer-care",
];

export default function Navigation() {
  const router = useRouter();
  const t = useTranslations();
  const { logout } = useAuthContext();
  const { configuration } = useConfiguration();

  const currentCountry = crossCountryUtils.getCurrentCountryCode(router);

  const { hasLoyaltyProgram, userSubscriptions } = useSubscriptions();

  const isUserSubscribedToLoyalty = loyaltyUtils.getLoyaltySubscription(userSubscriptions)?.Status === 2;

  return (
    <div className={styles.navigationWrapper}>
      <nav className={styles.nav}>
        <ul className={styles.navList}>
          {myAccountRoutes
            .filter((route) =>
              configuration["App:Ecommerce:EnabledPreferredStores"] === "true" ? true : route != "preferred-store"
            )
            .map((route, i) => {
              const splittedPath = router.asPath.split("/")[2];
              // if undefined we are on the dashboard, so route === '', otherwise check if selectedPath is the current route
              const selectedRoute = splittedPath === undefined ? "" === route : splittedPath === route;

              // logic to disable routes on different condition
              let routeHidden = false;
              let routeDisabled = false;
              switch (route) {
                case "loyalty":
                  routeHidden = !hasLoyaltyProgram ? true : false;
                  routeDisabled = !isUserSubscribedToLoyalty ? true : false;
              }

              // skip to next route if this one is hidden
              if (routeHidden) return null;

              return (
                <li
                  key={`${route}-${i}`}
                  className={classNames(
                    styles.navItem,
                    { [styles.navSelectedItem]: selectedRoute },
                    routeDisabled && styles.navItemDisabled
                  )}
                >
                  <Link
                    href={route}
                    onClick={(evt) => {
                      if (!routeDisabled) {
                        return undefined;
                      }

                      evt.preventDefault();
                      evt.stopPropagation();
                      return false;
                    }}
                  >
                    <motion.p initial={false} animate={{ paddingInlineStart: selectedRoute ? "22px" : 0 }}>
                      {t(`generic.myaccount.nav.${route == "" ? "dashboard" : route.split("-").join("")}`)}
                    </motion.p>
                    {selectedRoute && (
                      <motion.div className={styles.selectedBg} layoutId="selectedBg">
                        <Icon
                          name={"chevron-right"}
                          aria-hidden
                          width={16}
                          height={16}
                          className={styles.navItemIcon}
                        />
                      </motion.div>
                    )}
                  </Link>
                </li>
              );
            })}
        </ul>
      </nav>
      <Button
        className={classNames(buttonStyles.button, buttonStyles.secondary, styles.logoutBtn)}
        type="button"
        onClick={async () => {
          await logout();
          router.push(appRoutes.HOMEPAGE);
        }}
      >
        {t("generic.logout")}
      </Button>
    </div>
  );
}
